export default function AttributeEffect(data, tww_version) {
  this.tww_version = tww_version;

  this.phase = data.phase;
  this.attribute = data.attribute;
  this.attributeType = data.attribute_type;
}
